import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import { API_ENDPOINT } from '../../../constants';
import xIcon from '../../../assets/svg/x.svg';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import attachInvoice from '../../../assets/svg/attach.svg'

import checkIcon from '../../../assets/svg/check-icon.svg';
import calendar from '../../../assets/svg/calendar.svg';
import clockIcon from '../../../assets/svg/clock-icon.svg'





import Checkbox from '../../../components/forms/fields/checkbox';
import { getDetailedGroupPaymentMethods, getGroupPaymentMethods, getHumanReadable, getHumanReadableReasonForChange, getReasonsForChange } from '../helper';
import ErrorModal from '../../../components/errorModal';
import InfoModal from '../../../components/infoModal';
import striptags from 'striptags';
import DatePicker from '../../../components/forms/fields/datePicker';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class FreeCardDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            regions: [],
            freeCardData: {}
        };
    }

    getRegions = () => {
        fetch(API_ENDPOINT + '/data/regions', {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
        }).then(parseJSON).then(({ result, status }) => {
            let regions = result ?? [];
            this.setState({ regions });
        })
    }
    setInitialData = () => {
        this.setState({
            freeCardData: {
                detailsNotExists: true,
                number: null,
                regionId: null,
                regionData: null,
                valid: { from: null, to: null }
            },
        }, () => {
            this.onChange();
        })
    }

    componentDidMount() {
        this.getRegions();
        this.setInitialData();

    }

    componentWillUnmount() {
        this.handleShowErrors(false);
    }

    componentDidUpdate(prevProps, prevState) {


    }
    onChange = () => {
        this.checkValidation(() => {
            const errorExists = Object.keys(this.state.errors ?? {}).length > 0 ? true : false;
            const freeCardData = { ...this.state.freeCardData, errorExists: errorExists };
            if (this.props.onChange)
                this.props.onChange(freeCardData);
        });

    }
    checkValidation = (callback) => {
        const freeCardData = { ...this.state.freeCardData };
        let errors = {};

        const detailsNotExists = freeCardData?.detailsNotExists ?? false;
        if (!detailsNotExists) {
            const { number, regionId, valid } = freeCardData;

            if (!number || !number.trim()) errors.number = 'Free card number is required'.translate(this.props.lang);
            if (!regionId) errors.regionId = 'Region is required'.translate(this.props.lang);
            if (!valid?.from) errors.validFrom = 'Valid from date is required'.translate(this.props.lang);
            if (!valid?.to) errors.validTo = 'Valid to date is required'.translate(this.props.lang);

            if (valid.from && valid.to) {
                const tsNow = Math.floor(new Date().getTime() / 1000);
                const tsToCompare = this.props.checkTimestamp ? this.props.checkTimestamp : tsNow;
                let validFromDate = new Date(valid.from);
                validFromDate.setHours(0, 0, 0, 0);
                let validToDate = new Date(valid.to);
                validToDate.setHours(23, 59, 59, 999);
                const validFromTs = Math.floor(validFromDate.getTime() / 1000);
                const validToTs = Math.floor(validToDate.getTime() / 1000);

                if (validToTs < validFromTs) errors.validTo = 'Valid to date must be greater than or equal to Valid from date'.translate(this.props.lang);
                else if (tsToCompare < validFromTs || tsToCompare > validToTs) {
                    errors.validFrom = 'The current date must be between Valid from and Valid to dates'.translate(this.props.lang);
                    errors.validTo = 'The current date must be between Valid from and Valid to dates'.translate(this.props.lang);
                }
            }

        }

        if (JSON.stringify(errors) !== JSON.stringify(this.state.errors)) {
            this.setState({ errors }, () => {
                if (callback) callback(errors);
            });
        } else {
            if (callback) callback(errors);
        }

    }
    handleShowErrors = (value) => {
        if (this.props.handleShowErrors) {
            this.props.handleShowErrors(value);
        }
    }


    render() {
        const detailsNotExists = this.state.freeCardData?.detailsNotExists ?? false;
        const enterFreeCardDetails = !detailsNotExists;
        const errors = this.state.errors && this.props.showErrors ? this.state.errors : null;
        return (
            <div className='free-card-details-wrap'>
                <div className='section-title'>
                    {'If you have not reached the high-cost protection threshold, you will be charged retrospectively.'.translate(this.props.lang)}
                </div>
                <FormGroup>
                    <Checkbox
                        checked={enterFreeCardDetails}
                        onChange={() => {
                            let freeCardData = { ...this.state.freeCardData };
                            freeCardData.detailsNotExists = !detailsNotExists;
                            if (freeCardData.detailsNotExists) {
                                freeCardData.number = null;
                                freeCardData.regionId = null;
                                freeCardData.regionData = null;
                                freeCardData.valid = { from: null, to: null };
                                this.handleShowErrors(false);
                            }
                            this.setState({ freeCardData }, () => {
                                this.onChange();
                            });
                        }}
                        label={"Enter free card details manually".translate(this.props.lang)}
                    />
                </FormGroup>
                {
                    !detailsNotExists ?
                        <div className='free-card-details'>
                            <FormGroup className={errors?.number ? 'fg-has-error' : ''}>
                                <Label>{'Free card number'}</Label>
                                <Input
                                    type='text'
                                    value={this.state.freeCardData?.number ?? ''}
                                    onChange={(e) => {
                                        let freeCardData = { ...this.state.freeCardData };
                                        const value = striptags(e.target.value)
                                        freeCardData.number = value;
                                        this.setState({ freeCardData }, () => {
                                            this.onChange();
                                        });
                                    }}
                                />
                                {errors?.number ? <div className='error-feedback'>{errors?.number}</div> : null}
                            </FormGroup>
                            <FormGroup className={errors?.regionId ? 'fg-has-error' : ''}>
                                <Label>{'Issued at'.translate(this.props.lang)}</Label>
                                <Input
                                    type='select'
                                    value={this.state.freeCardData?.regionId}
                                    onChange={(e) => {
                                        let freeCardData = { ...this.state.freeCardData };
                                        const value = String(e.target.value) !== '-1' ? e.target.value : null;
                                        freeCardData.regionId = value;
                                        if (value) {
                                            const regionData = this.state.regions.find(r => r._id === value);
                                            freeCardData.regionData = {
                                                _id: regionData?._id ?? null,
                                                name: regionData?.name ?? '',
                                                shortName: regionData?.shortName ?? '',
                                                alias: regionData?.alias ?? ''
                                            }
                                        } else {
                                            freeCardData.regionData = null;
                                        }

                                        this.setState({ freeCardData }, () => {
                                            this.onChange();
                                        });
                                    }}
                                >
                                    <option value={-1}>{'None'.translate(this.props.lang)}</option>
                                    {
                                        this.state.regions?.map((item, idx) => {
                                            return (
                                                <option value={item._id}>{item.name}</option>
                                            )
                                        })
                                    }
                                </Input>
                                {errors?.regionId ? <div className='error-feedback'>{errors?.regionId}</div> : null}
                            </FormGroup>
                            <FormGroup className={errors?.validFrom ? 'fg-has-error' : ''}>
                                <DatePicker
                                    label={'Valid from'.translate(this.props.lang)}
                                    value={this.state.freeCardData?.valid?.from}
                                    onChange={(date) => {
                                        let freeCardData = { ...this.state.freeCardData };
                                        freeCardData.valid.from = date;
                                        this.setState({ freeCardData }, () => {
                                            this.onChange();
                                        });
                                    }}
                                />
                                {errors?.validFrom ? <div className='error-feedback'>{errors?.validFrom}</div> : null}
                            </FormGroup>
                            <FormGroup className={errors?.validTo ? 'fg-has-error' : ''}>
                                <DatePicker
                                    label={'Valid to'.translate(this.props.lang)}
                                    value={this.state.freeCardData?.valid?.to}
                                    onChange={(date) => {
                                        let freeCardData = { ...this.state.freeCardData };
                                        freeCardData.valid.to = date;
                                        this.setState({ freeCardData }, () => {
                                            this.onChange();
                                        });
                                    }}
                                />
                                {errors?.validTo ? <div className='error-feedback'>{errors?.validTo}</div> : null}
                            </FormGroup>
                        </div>
                        :
                        null
                }

            </div>
        );
    }
}


export default FreeCardDetails;